import { useEffect } from "react";
import { createPortal } from "react-dom";
import "./Loader.css";

const Loader = ({ message }) => {
  let lblTxt = message !== undefined ? message : "Loading please wait...";

  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);
  return createPortal(
    <div className="overlay">
      <div className="loader-txt">{lblTxt}</div>
      <div className="loader">
        <div className="double-ring">
          <div></div>
          <div></div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("modal-container")
  );
};

export const DivLoader = ({ message }) => {
  let lblTxt = message !== undefined ? message : "Loading please wait...";
  return (
    <div className="div-overlay-wrapper">
      <div className="div-overlay">
        <div className="div-loader-txt">{lblTxt}</div>
        <div className="div-loader">
          <div className="double-ring">
            <div></div>
            <div></div>
            <div>
              <div></div>
            </div>
            <div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;

export const loadingCellRenderer =
  '<div><div class="loader-txt loader-txt-txt-ag">Loading please wait...</div><div class="div-loader loader-txt-ag"><div class="double-ring"><div></div><div></div><div><div></div></div><div><div></div></div></div></div></div>';
